import { FunctionComponent, Suspense, lazy } from 'react'
import { ScrollToTop } from '../content/utilities/scrollToTop'
import { Header } from '../content/sections/header/Header'
import { PageLoading } from '../content/pages/helpers/PageLoading'
import { Footer } from '../content/sections/footer/Footer'
import { Outlet } from 'react-router-dom'

export const NotificationListComponent = lazy(() =>
    import('@vista-digital/occ-ui/src/lib/components/notification-list/notification-list').then(module => ({
        default: module.NotificationListComponent,
    }))
)

export const Layout: FunctionComponent = () => {
    return (
        <>
            <Header />
            <ScrollToTop />

            <div className="page-wrapper">
                <Outlet />
            </div>

            <Suspense fallback={<PageLoading />}>
                <NotificationListComponent />
            </Suspense>
            <Footer />
        </>
    )
}
